<div class="container">
  <ul>
    <li>
      <span class="title">Pago por</span>
      <span class="info">{{ payment.userName }}</span>
    </li>
    <li>
      <span class="title">Valor</span>
      <span class="info">{{ payment.value | currency }}</span>
    </li>
    <li>
      <span class="title">Data</span>
      <span class="info">{{ payment.tzDate }}</span>
    </li>
    <li>
      <span class="title">Hora</span>
      <span class="info">{{ payment.tzHour }}</span>
    </li>
  </ul>
  <ul class="ids">
    <li>
      <span class="title sm">ID da transação</span>
      <span class="info sm">{{ payment.paymentUuid }}</span>
    </li>
  </ul>
  <div class="itens" *ngIf="payment.items?.length">
    <div class="title" [class.collapsed]="collapsed" (click)="toggle()">
      <div class="left">
        <yoo-icon icon="receipt" [color]="collapsed ? '#000' : '#4B5053'" size="small"></yoo-icon>
        <span>Resumo dos pedidos</span>
      </div>
      <yoo-icon *ngIf="!collapsed" icon="caret-down" size="small" [color]="collapsed ? '#000' : '#4B5053'"></yoo-icon>
      <yoo-icon *ngIf="collapsed" icon="caret-up" size="small" [color]="collapsed ? '#000' : '#4B5053'"></yoo-icon>
    </div>
    @if(collapsed){
      @for(section of ownerSections; track section.userId){
        @if(section.name){
          <div class="owner-name">{{ section.name }}</div>
        }
        @for(item of section.items; track item){
          <app-receipt-item-table [item]="item"></app-receipt-item-table>
        }
      }
    }
  </div>
</div>